<template>
  <div>
    <p>Welcome Employee</p>
  </div>
</template>

<script>
export default {
  name: "EmployeeDashboard",
};
</script>

<style></style>
